import React, { useEffect, useState } from "react";
import { DashboardLayout, DeletePopupModal } from "../Components";
import { NavLink, useNavigate } from "react-router-dom";
import axiosConfig from "../Service/axiosConfig";
import DataTable from "react-data-table-component";
import { MdDeleteOutline, MdOutlineEdit } from "react-icons/md";
import { AiOutlineEye } from "react-icons/ai";
import AlertDeletePopupModal from "../Components/PopupModal/AlertDeletePopupModal";
import tableCustomStyles from "../Components/PopupModal/tableCustomStyles";
const TariffCardList = () => {
  const [visible, SetVisable] = useState([]);
  const [deletePopupType, setDeletepopupType] = useState("");
  const [loading, setLoading] = useState(false);
  const [AlertDeletePopupType, SetAlertDeletePopupType] = useState("");
  const [RowId, SetRowId] = useState();
  let navigate = useNavigate();
  const [search, SetSearch] = useState({
    search: "",
  });
  const [Datafilter, SetDatafilter] = useState([]);
  const [Data, SetData] = useState([]);
  const GetData = async () => {
    setLoading(true);
    try {
      const responce = await axiosConfig.get("/masters/tariffcategories/");
      console.log(responce);
      SetData(responce.data);
      SetDatafilter(responce.data);
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };
  const HandleSearch = (e) => {
    e.preventDefault();
    const name = e.target.name;
    const value = e.target.value;
    console.log(name, value);
    SetSearch({ ...search, [name]: value });
    const response = Datafilter.filter(
      (data) =>
        (data.tariffcategory_code &&
          data.tariffcategory_code
            .toLowerCase()
            .includes(value.toLowerCase())) ||
        (data.tarifftype_code &&
          data.tarifftype_code.toLowerCase().includes(value.toLowerCase()))
    );
    console.log(response);
    SetData(response);
  };
  useEffect(() => {
    GetData();
  }, []);

  const columns = [
    {
      name: "S.No",
      selector: (row, i) => i + 1,
      sortable: true,
    },
    {
      name: "Id",
      selector: (row) => row.id,
      sortable: true,
    },
    {
      name: "Code",
      selector: (row) => row.tariffcategory_code,
      sortable: true,
    },
    {
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      name: "Tariff Type",
      selector: (row) => row.tarifftype_code,
      sortable: true,
    },
    {
      name: "ACTIONS",
      selector: (row) => {
        const HandleEdit = async () => {
          return navigate(`/dashboard/masters/tariffcard/${row.id}/edit`);
        };
        const DeleteAlert = () => {
          SetRowId(row.id);
          SetAlertDeletePopupType("success");
        };
        const CancelAlerrt = () => {
          SetAlertDeletePopupType("error");
        };
        const HandleDelete = async (id) => {
          await axiosConfig
            .delete(`/masters/tariffcategories/${id}/`)
            .then(() => {
              setDeletepopupType("success");
              SetAlertDeletePopupType("error");
              GetData();
            })
            .catch((error) => {
              console.log(error);
              setDeletepopupType("error");
              SetAlertDeletePopupType("error");
            });
        };
        const HandleView = async (id) => {
          return navigate(`/dashboard/masters/tariffcard/${row.id}/edit`);
        };
        return (
          <>
            <div className="row">
              <div className="col-4">
                <AiOutlineEye
                  className="dashboard-tabe-data-actions"
                  onClick={HandleEdit}
                />
              </div>
              <div className="col-4">
                <MdOutlineEdit
                  className="dashboard-tabe-data-actions"
                  onClick={HandleEdit}
                />
              </div>
              <div className="col-4">
                <MdDeleteOutline
                  className="dashboard-tabe-data-actions"
                  onClick={DeleteAlert}
                />
              </div>
            </div>
            {AlertDeletePopupType === "success" && (
              <AlertDeletePopupModal
                AlertDeletePopupType={AlertDeletePopupType}
                HandleDelete={HandleDelete}
                CancelAlerrt={CancelAlerrt}
                row={RowId}
              />
            )}
          </>
        );
      },
    },
  ];
  return (
    <>
      <DashboardLayout>
        <div className="dashboard-header">
          <h5 className="dashboard-subtitle">View Tariff Card</h5>
          <NavLink to="/dashboard/masters/tariffcard/add">
            <button className="btn btn-white">Add New</button>
          </NavLink>
        </div>
        <div className="table-responsive">
          <DataTable
            columns={columns}
            data={Data}
            pagination
            draggableColumns
            fixedHeader
            subHeader
            customStyles={tableCustomStyles}
            progressPending={loading}
            progressComponent={
              <div className="loader-container">
                <img
                  src={require("../Components/FormParser/images/loader2.gif")}
                  alt="Loading..."
                />
              </div>
            }
            subHeaderComponent={
              <input
                type="text"
                className="form-control w-25"
                name="search"
                value={search.search}
                onChange={HandleSearch}
              />
            }
          />
        </div>
        {deletePopupType != "" && (
          <DeletePopupModal
            setDeletepopupType={setDeletepopupType}
            deletePopupType={deletePopupType}
          />
        )}
      </DashboardLayout>
    </>
  );
};
export { TariffCardList };
